export var ConsentBankState;
(function (ConsentBankState) {
    ConsentBankState["VALIDATING"] = "VALIDATING";
    ConsentBankState["VALID"] = "VALID";
    ConsentBankState["INVALID"] = "INVALID";
    ConsentBankState["PENDING_ADDITIONAL_CONFIRMATION"] = "PENDING_ADDITIONAL_CONFIRMATION";
    ConsentBankState["PENDING"] = "PENDING";
    ConsentBankState["ERROR"] = "ERROR";
    ConsentBankState["CONNECTING"] = "CONNECTING";
    ConsentBankState["CONNECTED"] = "CONNECTED";
    ConsentBankState["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ConsentBankState["PENDING_DEVICE_ENABLED"] = "PENDING_DEVICE_ENABLED";
    ConsentBankState["CONNECTION_CLOSED"] = "CONNECTION_CLOSED";
    ConsentBankState["WAITING_SECOND_SIGNATURE"] = "WAITING_SECOND_SIGNATURE";
    ConsentBankState["PENDING_MULTIPLE_SIGNATURES"] = "PENDING_MULTIPLE_SIGNATURES";
    ConsentBankState["REDO_CONSENTMENT"] = "REDO_CONSENTMENT";
})(ConsentBankState || (ConsentBankState = {}));
export var OpenFinanceBankTypes;
(function (OpenFinanceBankTypes) {
    OpenFinanceBankTypes["BANCO_DO_BRASIL"] = "BANCO_DO_BRASIL";
    OpenFinanceBankTypes["BANRISUL"] = "BANRISUL";
    OpenFinanceBankTypes["BRADESCO"] = "BRADESCO";
    OpenFinanceBankTypes["CAIXA"] = "CAIXA";
    OpenFinanceBankTypes["ITAU"] = "ITAU";
    OpenFinanceBankTypes["NUBANK"] = "NUBANK";
    OpenFinanceBankTypes["SANTANDER"] = "SANTANDER";
    OpenFinanceBankTypes["SICOOB"] = "SICOOB";
    OpenFinanceBankTypes["SICREDI"] = "SICREDI";
    OpenFinanceBankTypes["UNICRED"] = "UNICRED";
    OpenFinanceBankTypes["PLUGGY"] = "PLUGGY";
    OpenFinanceBankTypes["INTER"] = "INTER";
    OpenFinanceBankTypes["C6_BANK"] = "C6_BANK";
})(OpenFinanceBankTypes || (OpenFinanceBankTypes = {}));
export var BelvoTokenStatusEnum;
(function (BelvoTokenStatusEnum) {
    BelvoTokenStatusEnum["application_link"] = "application_link";
    BelvoTokenStatusEnum["success"] = "success";
    BelvoTokenStatusEnum["event"] = "event";
    BelvoTokenStatusEnum["exit"] = "exit";
})(BelvoTokenStatusEnum || (BelvoTokenStatusEnum = {}));
export var OpenFinanceFeedbackEnum;
(function (OpenFinanceFeedbackEnum) {
    OpenFinanceFeedbackEnum["APPLICATION_LINK"] = "application-link";
    OpenFinanceFeedbackEnum["SUCCESS"] = "success";
    OpenFinanceFeedbackEnum["EXIT"] = "exit";
    OpenFinanceFeedbackEnum["EVENT"] = "event";
})(OpenFinanceFeedbackEnum || (OpenFinanceFeedbackEnum = {}));
export var ConsentPartner;
(function (ConsentPartner) {
    ConsentPartner["PLUGGY"] = "PLUGGY";
    ConsentPartner["BELVO"] = "BELVO";
})(ConsentPartner || (ConsentPartner = {}));
export var ConsentTransactionType;
(function (ConsentTransactionType) {
    ConsentTransactionType["PIX"] = "PIX";
    ConsentTransactionType["TRANSFERENCE"] = "TRANSFERENCE";
    ConsentTransactionType["BILL"] = "BILL";
})(ConsentTransactionType || (ConsentTransactionType = {}));
export var ConsentTransactionTypeEnum;
(function (ConsentTransactionTypeEnum) {
    ConsentTransactionTypeEnum["CREDIT"] = "CREDIT";
    ConsentTransactionTypeEnum["DEBIT"] = "DEBIT";
})(ConsentTransactionTypeEnum || (ConsentTransactionTypeEnum = {}));
